import React from 'react';
import { observer, inject } from 'mobx-react';
import Container from './Container';
import Row from './Row';

export default inject('page')(
  observer(({ page }) => (
    <Container>
      <Row bold>
        {page.address.address1}
        {page.address.address2 && `, ${page.address.address2}`}
      </Row>
      <Row>
        {page.address.city} {page.address.state}, {page.address.zip}
      </Row>
    </Container>
  )),
);
